import moment from 'moment';
import Cookies from 'universal-cookie';

const calculateTimeDifference = (startTime, maxBreakDuration, remainingDurationSec) => {
  if (!startTime) return 0;

  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  const target = moment.tz(startTime, timezone);

  const limit = target.clone().add(maxBreakDuration, 'minutes').add(remainingDurationSec, 'seconds');

  const now = moment.tz(timezone);

  const diff = limit.diff(now, 'seconds');

  return diff;
};

export default calculateTimeDifference;
